// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CommunicationChannelsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CommunicationChannelsQuery = { __typename?: 'Query', communicationChannels: Array<{ __typename?: 'CommunicationChannelDetail', code: Types.CommunicationChannel, name: string }> };

export type UserCommunicationPreferencesQueryVariables = Types.Exact<{
  user: Types.Scalars['ID']['input'];
}>;


export type UserCommunicationPreferencesQuery = { __typename?: 'Query', userCommunicationPreferences?: { __typename?: 'UserCommunicationPreference', id: string, commentPreference?: Array<Types.CommunicationChannel> | null | undefined, tpAvailabilityRequestPreference?: Array<Types.CommunicationChannel> | null | undefined, user: { __typename?: 'User', id: string, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, tradePartnerContact?: { __typename?: 'TradePartnerContact', id: string } | null | undefined }> } } | null | undefined };

export type SaveUserCommunicationPreferenceMutationVariables = Types.Exact<{
  input: Types.SaveUserCommunicationPreferenceInput;
}>;


export type SaveUserCommunicationPreferenceMutation = { __typename?: 'Mutation', saveUserCommunicationPreference: { __typename?: 'SaveUserCommunicationPreferenceResult', userCommunicationPreference: { __typename?: 'UserCommunicationPreference', id: string, commentPreference?: Array<Types.CommunicationChannel> | null | undefined, tpAvailabilityRequestPreference?: Array<Types.CommunicationChannel> | null | undefined, user: { __typename?: 'User', id: string, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, tradePartnerContact?: { __typename?: 'TradePartnerContact', id: string } | null | undefined }> } } } };

export type UserCommPreferences_UserCommunicationPreferenceFragment = { __typename?: 'UserCommunicationPreference', id: string, commentPreference?: Array<Types.CommunicationChannel> | null | undefined, tpAvailabilityRequestPreference?: Array<Types.CommunicationChannel> | null | undefined, user: { __typename?: 'User', id: string, tradePartnerUsers: Array<{ __typename?: 'TradePartnerUser', id: string, tradePartnerContact?: { __typename?: 'TradePartnerContact', id: string } | null | undefined }> } };

export const UserCommPreferences_UserCommunicationPreferenceFragmentDoc = gql`
    fragment UserCommPreferences_UserCommunicationPreference on UserCommunicationPreference {
  id
  user {
    id
    tradePartnerUsers {
      id
      tradePartnerContact {
        id
      }
    }
  }
  commentPreference
  tpAvailabilityRequestPreference
}
    `;
export const CommunicationChannelsDocument = gql`
    query CommunicationChannels {
  communicationChannels {
    code
    name
  }
}
    `;

/**
 * __useCommunicationChannelsQuery__
 *
 * To run a query within a React component, call `useCommunicationChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunicationChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunicationChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunicationChannelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CommunicationChannelsQuery, CommunicationChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CommunicationChannelsQuery, CommunicationChannelsQueryVariables>(CommunicationChannelsDocument, options);
      }
export function useCommunicationChannelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CommunicationChannelsQuery, CommunicationChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CommunicationChannelsQuery, CommunicationChannelsQueryVariables>(CommunicationChannelsDocument, options);
        }
export function useCommunicationChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CommunicationChannelsQuery, CommunicationChannelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CommunicationChannelsQuery, CommunicationChannelsQueryVariables>(CommunicationChannelsDocument, options);
        }
export type CommunicationChannelsQueryHookResult = ReturnType<typeof useCommunicationChannelsQuery>;
export type CommunicationChannelsLazyQueryHookResult = ReturnType<typeof useCommunicationChannelsLazyQuery>;
export type CommunicationChannelsSuspenseQueryHookResult = ReturnType<typeof useCommunicationChannelsSuspenseQuery>;
export type CommunicationChannelsQueryResult = Apollo.QueryResult<CommunicationChannelsQuery, CommunicationChannelsQueryVariables>;
export const UserCommunicationPreferencesDocument = gql`
    query UserCommunicationPreferences($user: ID!) {
  userCommunicationPreferences(user: $user) {
    ...UserCommPreferences_UserCommunicationPreference
  }
}
    ${UserCommPreferences_UserCommunicationPreferenceFragmentDoc}`;

/**
 * __useUserCommunicationPreferencesQuery__
 *
 * To run a query within a React component, call `useUserCommunicationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCommunicationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCommunicationPreferencesQuery({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUserCommunicationPreferencesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserCommunicationPreferencesQuery, UserCommunicationPreferencesQueryVariables> & ({ variables: UserCommunicationPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserCommunicationPreferencesQuery, UserCommunicationPreferencesQueryVariables>(UserCommunicationPreferencesDocument, options);
      }
export function useUserCommunicationPreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserCommunicationPreferencesQuery, UserCommunicationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserCommunicationPreferencesQuery, UserCommunicationPreferencesQueryVariables>(UserCommunicationPreferencesDocument, options);
        }
export function useUserCommunicationPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserCommunicationPreferencesQuery, UserCommunicationPreferencesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserCommunicationPreferencesQuery, UserCommunicationPreferencesQueryVariables>(UserCommunicationPreferencesDocument, options);
        }
export type UserCommunicationPreferencesQueryHookResult = ReturnType<typeof useUserCommunicationPreferencesQuery>;
export type UserCommunicationPreferencesLazyQueryHookResult = ReturnType<typeof useUserCommunicationPreferencesLazyQuery>;
export type UserCommunicationPreferencesSuspenseQueryHookResult = ReturnType<typeof useUserCommunicationPreferencesSuspenseQuery>;
export type UserCommunicationPreferencesQueryResult = Apollo.QueryResult<UserCommunicationPreferencesQuery, UserCommunicationPreferencesQueryVariables>;
export const SaveUserCommunicationPreferenceDocument = gql`
    mutation SaveUserCommunicationPreference($input: SaveUserCommunicationPreferenceInput!) {
  saveUserCommunicationPreference(input: $input) {
    userCommunicationPreference {
      ...UserCommPreferences_UserCommunicationPreference
    }
  }
}
    ${UserCommPreferences_UserCommunicationPreferenceFragmentDoc}`;
export type SaveUserCommunicationPreferenceMutationFn = Apollo.MutationFunction<SaveUserCommunicationPreferenceMutation, SaveUserCommunicationPreferenceMutationVariables>;

/**
 * __useSaveUserCommunicationPreferenceMutation__
 *
 * To run a mutation, you first call `useSaveUserCommunicationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserCommunicationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserCommunicationPreferenceMutation, { data, loading, error }] = useSaveUserCommunicationPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUserCommunicationPreferenceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveUserCommunicationPreferenceMutation, SaveUserCommunicationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveUserCommunicationPreferenceMutation, SaveUserCommunicationPreferenceMutationVariables>(SaveUserCommunicationPreferenceDocument, options);
      }
export type SaveUserCommunicationPreferenceMutationHookResult = ReturnType<typeof useSaveUserCommunicationPreferenceMutation>;
export type SaveUserCommunicationPreferenceMutationResult = Apollo.MutationResult<SaveUserCommunicationPreferenceMutation>;
export type SaveUserCommunicationPreferenceMutationOptions = Apollo.BaseMutationOptions<SaveUserCommunicationPreferenceMutation, SaveUserCommunicationPreferenceMutationVariables>;